export interface IMedia {
  url: string;
  type: EType;
}

export enum EType {
  Layout = 'layout',
  CianLayout = 'cianLayout',
  Photo = 'photo',
  Video = 'video',
}
